export const ajaxTimeout = 30000;
export const pagesWithoutLogin = ['/', '/err', '/imprint'];
export const maxResults = 3000;
